<template lang="pug">
.d-inline-flex.align-center.justify-center
  v-icon(v-if="parentActiveMedications.isError" size="20" color="danger500") mdi-alert-circle-outline
  div(v-else)
    yc-checkbox(v-if="item.productItem && ['medication', 'consumable'].includes(item.productItem.type)" :key="activeKey" :input-value="item.active" @change="handleChangeActiveMedication($event, item)")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    treatments: {
      type: Array,
      required: true
    },
    patient: {
      type: Object,
      required: true
    },
    parentActiveMedications: {
      type: Object,
      default: () => {
        return {
          isFetching: false,
          isError: false,
          data: [],
        }
      }
    }
  },
  data() {
    return {
      activeKey: 0
    }
  },
  computed: {
    ...mapGetters({company: 'getCompany'})
  },
  methods: {
    ...mapActions(['showMessage']),
    async handleChangeActiveMedication (event, item) {
      const index = this.treatments.findIndex(treatment => treatment.number === item.number)
      try {
        if (event) {
          const payload = {
            patient: this.patient.id,
            medication: item.productItem.medication.id,
          }
          const endpoint = `/clinics/${this.company.slug}/active_medications`
          const { data } = await this.$axios.post(endpoint, payload)
          this.updateActivityLog(endpoint, payload, data, 'POST', data.id, this.patient.id, item.productItem.medication.id)
          this.showMessage(['success', 'Medication added to active list'])
        } else {
          const activeMedication = this.parentActiveMedications.data.find(med => med.medication.id === item.productItem.medication.id)
          if (activeMedication) {
            const endpoint = `/clinics/${this.company.slug}/active_medications/${activeMedication.id}`
            await this.$axios.delete(endpoint)
            this.updateActivityLog(endpoint, null, null, 'DELETE', activeMedication.id, this.patient.id, item.productItem.medication.id)
            this.showMessage(['success', 'Medication removed from active list'])
          }
        }
        this.treatments[index].active = event
        this.$emit('updateActiveMedications')
      } catch (error) {
        this.treatments[index].active = !event
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.activeKey++
      }
    },
    updateActivityLog (endpoint, payload, response, method, objectId, patientId, medicationId) {
      const action = method === 'POST' ? 'Activate' : 'Deactivate'
      let data = {
        company: this.company.id,
        object_id: objectId,
        object_ref: 'active_medications',
        activity: `${action} active medications (patient_id: ${patientId}, medication_id: ${medicationId})`,
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
</style>